function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
/* eslint-disable react/prop-types */
import React from 'react';
import FontAwesome from 'react-fontawesome';
import ReactTooltip from 'react-tooltip';
import InputLabel from "./InputLabel";
import TextareaErrorContainer from "./TextAreaErrorContainer";
import { _InputWrapperDiv, _LongInputWrapperDiv, _TextAreaInput } from "./inputStyles";
var TextAreaInput = function TextAreaInput(props) {
  var wrapperClassName = [props.required ? 'required' : null, props.error ? 'error' : null, props.disabled ? 'disabled' : null, 'text-area-input'].filter(function (e) {
    return !!e;
  }).join(' ');
  var value = props.inputValue || props.input && props.input.value || '';
  var elementClassName = value === '' ? 'empty' : null;
  return /*#__PURE__*/React.createElement(_LongInputWrapperDiv, {
    className: wrapperClassName,
    noPadding: props.noPadding
  }, /*#__PURE__*/React.createElement(_InputWrapperDiv, {
    noPadding: props.noPadding
  }, /*#__PURE__*/React.createElement(InputLabel, {
    labelText: props.labelText,
    required: props.required,
    subLabel: props.subLabel
  }), props.tooltip && /*#__PURE__*/React.createElement(FontAwesome, {
    "data-tip": props.tooltip,
    name: "info-circle",
    css: "cursor: pointer"
  }), /*#__PURE__*/React.createElement(TextareaErrorContainer, {
    error: props.error || props.meta && props.meta.touched && props.meta.error
  })), /*#__PURE__*/React.createElement(_InputWrapperDiv, {
    noPadding: props.noPadding
  }, /*#__PURE__*/React.createElement(_TextAreaInput, _extends({}, props, props.input, {
    className: elementClassName,
    "data-inputid": props.inputId,
    id: props.inputId,
    rows: "3",
    value: value
  }))), /*#__PURE__*/React.createElement(ReactTooltip, null));
};
export default TextAreaInput;